import React from "react";
import styles from "../FundingRelease/index.module.css";
import Container from "../../Components/General/Container";
import fundingImg from "../../assets/investment_announcement.png";

const FundingRelease80Cr = () => {
  return (
    <Container>
      <div className={styles.fundingContainer}>
        <div className={styles.fundingHeader}>
     NowPurchase Raises ₹80 Crores led by Bajaj Finserv
        </div>
        <img
          className={styles.fundingImg}
          src={fundingImg}
          alt="Press Release"
        />
        <div className={styles.description}>
          <strong>Kolkata, April 1, 2026 –{" "}</strong>
          <a href="https://nowpurchase.com/" target="blank" rel="noopener noreferrer">
            NowPurchase
          </a>
          {" "}an AI enabled B2B platform that helps metal manufacturers optimize
          production and procure raw materials, today announced the successful
          raise of 80 crores led by Bajaj Finserv, one of India's largest and
          most diversified financial services groups, with participation from
          existing investors InfoEdge Ventures &amp; Orios Venture Partners. The
          round also saw participation from prominent individual investors &amp;
          family offices including Shikhar Raj, Real Ispat Group, Madhur Gupta
          (Promoter &amp; Director of Lloyds Group), VC Grid, and Professor
          Kartik Hosanagar.
        </div>
        <div className={styles.description}>
          The newly raised capital will be strategically deployed to accelerate
          key growth initiatives, with NowPurchase focusing on strengthening its
          core offerings such as{" "}
          <a href="/scrap-recycling" target="blank" rel="noopener noreferrer">
            scrap recycling
          </a>
          , expanding its portfolio of branded products, and scaling its
          AI-powered platform,{" "}
          <a href="/metalcloud" target="blank" rel="noopener noreferrer">
            MetalCloud
          </a>
          .
        </div>
        <div className={styles.description}>
          NowPurchase, founded in 2017 by{" "}
          <a href="https://www.linkedin.com/in/namanshah1/" target="blank" rel="noopener noreferrer">
            Naman Shah
          </a>{" "}
          and{" "}
          <a href="https://www.linkedin.com/in/shahaakash/" target="blank" rel="noopener noreferrer">
            Aakash Shah
          </a>
          , with an initial investment of $300K from Nipha Group offers an AI
          enabled procurement solution that enables metal manufacturers to source
          high-quality raw materials such as scrap, alloys, and additives in a
          transparent and reliable manner. The company differentiates itself
          through its network of scrap processing centers and branded products
          for alloys and additives. NowPurchase's AI platform{" "}
          <a href="/metalcloud" target="blank" rel="noopener noreferrer">
            MetalCloud
          </a>{" "}
          helps metal manufacturers digitize &amp; optimize their production
          process leveraging IoT &amp; Computer Vision.
        </div>
        <div className={`${styles.description} ${styles.leftBorderIndicator}`}>
          <div className={styles.italicsText}>
            "We are delighted to have Bajaj Finserv as a partner in our next
            phase of growth. This investment will accelerate our investment in
            R&amp;D capabilities &amp; scrap recycling infrastructure to drive
            innovation and create meaningful value for our customers. Backed by
            a strong pan-India presence and an expanding global footprint,
            NowPurchase is well-positioned to double down on its core operations
            and continue scaling with strong unit economics."
          </div>
          <b> - Naman Shah, Founder &amp; CEO, NowPurchase</b>
        </div>
        <div className={`${styles.description} ${styles.leftBorderIndicator}`}>
          <div className={styles.italicsText}>
            "This funding will fast-track the growth of MetalCloud—our
            AI-powered platform built to digitize and optimize production in
            metal manufacturing. We believe AI can fundamentally transform
            shop-floor operations, and MetalCloud is positioned to lead that
            shift."
          </div>
          <b> - Aakash Shah, Co-founder NowPurchase</b>
        </div>
        <div className={`${styles.description} ${styles.leftBorderIndicator}`}>
          <div className={styles.italicsText}>
            "We are pleased to join hands at a defining moment in the growth
            journey of NowPurchase. The company's strong nationwide pan-India
            presence, expanding global ambitions, and its AI-enabled platform,
            positions it well to transform the metal manufacturing ecosystem."
          </div>
          <b> - Mrs. Lakshmi Iyer, CEO of Bajaj Alternates</b>
        </div>
        <div className={`${styles.description} ${styles.leftBorderIndicator}`}>
          <div className={styles.italicsText}>
            "This investment reflects our conviction in using technology to
            drive efficiency, innovation, and resilience across procurement,
            finance, and the company's supply chain. We are committed to
            supporting NowPurchase's scale-up journey and enabling long-term
            value creation."
          </div>
          <b>
            {" "}
            - Mr. Girish Jhunjhunwala, Fund Manager – PE and VC Investments at
            Bajaj Alternates
          </b>
        </div>
        <div className={styles.description}>
          With this latest infusion, NowPurchase has raised approximately ₹120
          crore (14.46 million USD) in total equity funding to date.
        </div>
        <div className={styles.footer}>
          <strong>About NowPurchase:</strong>
          <div className={styles.description}>
            NowPurchase is an AI enabled B2B platform where Metal Manufacturers
            can procure high quality raw materials like metal scrap, alloys and
            additives in a trusted &amp; transparent manner. NowPurchase has
            taken a novel approach with its own network of scrap processing
            centers &amp; branded products for additives &amp; alloys. Its AI
            platform{" "}
            <a href="/metalcloud" target="blank" rel="noopener noreferrer">
              MetalCloud
            </a>{" "}
            helps metal manufacturers digitize &amp; optimize their production
            process leveraging IoT &amp; Computer Vision.
            <br />
            <br />
            NowPurchase was founded in 2017 by{" "}
            <a href="https://www.linkedin.com/in/namanshah1/" target="blank" rel="noopener noreferrer">
              Naman Shah
            </a>{" "}
            and{" "}
            <a href="https://www.linkedin.com/in/shahaakash/" target="blank" rel="noopener noreferrer">
              Aakash Shah
            </a>
            , with an initial investment of $300K from Nipha Group. The company
            draws on Naman's experience with multiple startups in the US and
            Singapore, where he witnessed firsthand the transformative power of
            technology for businesses. Aakash's two decades of manufacturing
            experience has helped the company with its supply chain &amp;
            building the right solutions for metal manufacturers. With a
            comprehensive range of services and solutions, NowPurchase aims to
            expand its geographic footprint and become the leading procurement
            platform for all metal manufacturers.{" "}
            <a href="https://www.linkedin.com/in/ankan-adhikari/" target="blank" rel="noopener noreferrer">
              Ankan Adhikari
            </a>{" "}
            joined the core team in 2019 as a CTO. Ankan is a serial
            entrepreneur whose previous EdTech venture was acquired by UpGrad.
          </div>
        </div>
      </div>
    </Container>
  );
};

export default FundingRelease80Cr;
